export const Vortex = {
  period: 14,
};

export const KST = {
  sourcePath: "close",
  roc1: 10,
  sma1: 10,
  roc2: 15,
  sma2: 10,
  roc3: 20,
  sma3: 10,
  roc4: 30,
  sma4: 15,
  signal: 9,
};

export const BollingerBand = {
  windowSize: 20,
  // source: d => d.close, // "high", "low", "open", "close"
  sourcePath: "close",
  multiplier: 2,
  movingAverageType: "sma",
};

export const BollingerBandwidth = {
  windowSize: 20,
  sourcePath: "close",
  multiplier: 2,
  movingAverageType: "sma",
};

export const BollingerPercentB = {
  windowSize: 20,
  sourcePath: "close",
  multiplier: 2,
  movingAverageType: "sma",
};

export const ATR = {
  windowSize: 14,
};

export const ATRBands = {
  windowSize: 5,
  sourcePath: "close",
  multiplier: 3,
};

export const ATRStop = {
  period: 21,
  multiplier: 3,
  plotType: "points",
  useHighLow: false,
};

export const TRIX = {
  period: 14,
  sourcePath: "close",
};

export const keltner = {
  period: 50,
  multiplier: 5,
  sourcePath: "close",
  movingAverageType: "ema",
};

export const WilliamsR = {
  period: 14,
};

export const ForceIndex = {
  sourcePath: "close", // "high", "low", "open", "close"
  volumePath: "volume",
};
export const SmoothedForceIndex = {
  sourcePath: "close", // "high", "low", "open", "close"
  volumePath: "volume",
  m1Period: 2,
  m2Period: 13,
};
export const Change = {
  sourcePath: "close", // "high", "low", "open", "close"
};
export const Compare = {
  basePath: "close",
  mainKeys: ["open", "high", "low", "close"],
  compareKeys: [],
};

export const ElderRay = {
  windowSize: 13,
  // source: d => d.close, // "high", "low", "open", "close"
  sourcePath: "close", // "high", "low", "open", "close"
  movingAverageType: "sma",
};

export const ElderImpulse = {
  sourcePath: "close", // "high", "low", "open", "close"
};

// SAR — porte fiel do engine Silverlight (FML.SAR). Os três parâmetros do
// engine: ACCEL (AF inicial e reset da virada), STEP (incremento quando o EP
// melhora) e MAXP (teto). `accelerationStep` ausente ⇒ Wilder clássico, com o
// incremento igual ao AF inicial.
export const SAR = {
  accelerationFactor: 0.02,
  accelerationStep: 0.02,
  maxAccelerationFactor: 0.2,
};

export const MACD = {
  fast: 12,
  slow: 26,
  signal: 9,
  // source: d => d.close, // "high", "low", "open", "close"
  sourcePath: "close",
};

export const Klinger = {
  signalPeriods: 13,
  shortCycle: 34,
  longCycle: 55,
};

export const Ichimoku = {
  conversionPeriod: 9,
  basePeriod: 26,
  spanBPeriod: 52,
  displacement: 26,
};

export const FullStochasticOscillator = {
  windowSize: 12,
  kWindowSize: 3,
  dWindowSize: 3,
};

export const RSI = {
  windowSize: 14,
  // source: d => d.close, // "high", "low", "open", "close"
  sourcePath: "close", // "high", "low", "open", "close"
};

// VRSI — IFR do Volume (migrado do Silverlight FML.VRSI; paridade via oráculo)
export const VRSI = {
  period: 6,
};

// VSTD — Desvio Padrão do Volume (migrado do Silverlight FML.VSTD; paridade via oráculo)
export const VSTD = {
  period: 10,
};

// StochRSI — IFR Estocástico (migrado do Silverlight FML.StochRSI; paridade via oráculo)
export const StochRSI = {
  period: 14,
};

// RSICutler — IFR variante Cutler (SMA), 2 linhas RSI+sinal (FML.RSICutler; paridade via oráculo)
export const RSICutler = {
  period: 9,
  average: 5,
};

export const MFI = {
  windowSize: 14,
};

// BBI — Bullish-Bearish, média de 4 MAs aritméticas do fechamento (FML.BBI; paridade via oráculo)
export const BBI = {
  sourcePath: "close",
  n1: 3,
  n2: 6,
  n3: 12,
  n4: 24,
};

// HighLowMa — High & Low do Silverlight: MAs aritméticas de máximas/mínimas com
// deslocamento vertical % opcional (FML.HighLow; ≠ highLow HHV/LLV do odin)
export const HighLowMa = {
  mHigh: 20,
  mLow: 20,
  deslocV: 0,
};

// DIDIHIST — DIDI Histograma do Silverlight (FML.DIDIHIST): painel próprio,
// histograma = (MA(C,HIGH)−MA(C,MID)) − (MA(C,LOW)−MA(C,MID)) + linha zero
export const DIDIHIST = {
  sourcePath: "close",
  highPeriod: 3,
  midPeriod: 8,
  lowPeriod: 20,
};

// BBIBOLL — Bullish-Bear Bollinger (FML.BBIBOLL): banda sobre o BBI
// (BBI fixo 3/6/12/24) ± P·STD(BBI,N). Overlay de preço, 3 linhas.
export const BBIBOLL = {
  sourcePath: "close",
  period: 10, // N — janela do desvio-padrão
  multiplier: 3, // P — fator da banda
};

// LinRegrChannel — Canais de Regressão Linear (FML.LinRegr): canal ESTÁTICO
// sobre as últimas N barras; A=LR(C,N), M=max(|desvios|)·P/100, UPPER/LOWER=A±M.
export const LinRegrChannel = {
  sourcePath: "close",
  period: 14, // N — janela da regressão (barras finais)
  percent: 100, // P — % do desvio máximo aplicado às bandas
};

// DDI — Índice divergência direcional 2 (FML.DDI; FALSO-AMIGO do didi/DIDI Linhas):
// painel próprio, histograma DDI=DIZ−DIF + ADDI=SMA-chinesa(DDI,N1,M) + AD=MA(ADDI,M1).
export const DDI = {
  n: 13, // janela do SUM (DIZ/DIF)
  n1: 30, // janela da SMA-chinesa (ADDI)
  m: 10, // peso da SMA-chinesa (ADDI)
  m1: 5, // janela da MA (AD)
};

// AccumDist — Acumulação & Distribuição de Chaikin (FML.AD; ≠ williamsad):
// AD=SUM(((C−L)−(H−C))/(H−L)·VOL, 0) acumulado + M=MA(AD,N). Usa VOLUME.
export const AccumDist = {
  n: 20,
};

// WVAD — Acumulação/Distribuição William Variável (FML.WVAD; ≠ williamsad):
// WVAD=(C−O)/(H−L)·VOL + MA1=MA(WVAD,N1) + MA2=MA(WVAD,N2). Usa VOLUME.
export const WVAD = {
  n1: 10,
  n2: 20,
};

// VMACD — MACD do Volume (FML.VMACD): DIFF=EMA(VOL,SHORT)−EMA(VOL,LONG),
// DEA=EMA(DIFF,M), MACD=DIFF−DEA (COLORSTICK). Usa VOLUME.
export const VMACD = {
  short: 12,
  long: 26,
  m: 9,
};

// SO — Oscilador Estocástico (FML.SO; ≠ stochastic rolling do odin): K=(C−L)/(H−L)
// na PRÓPRIA barra, SK=SMA-chinesa(K,N1,1), SD=SMA(SK,N2,1). Escala 0–1.
export const SO = {
  n1: 3,
  n2: 3,
};

export const SchaffTrendCycle = {
  period: 10, // Stochastic period
  shortCycle: 23, // MACD short EMA period
  longCycle: 50, // MACD long EMA period
  sourcePath: "close", // Source field
  movingAverageType: "ema", // Moving average type
};

export const EMA = {
  // source: d => d.close, // "high", "low", "open", "close"
  sourcePath: "close",
  windowSize: 10,
};

export const SMA = {
  // source: d => d.close, // "high", "low", "open", "close"
  sourcePath: "close",
  windowSize: 10,
};

export const WMA = {
  // source: d => d.close, // "high", "low", "open", "close"
  sourcePath: "close",
  windowSize: 10,
};

export const HMA = {
  sourcePath: "close",
  windowSize: 9,
};

export const TMA = {
  // source: d => d.close, // "high", "low", "open", "close"
  sourcePath: "close",
  windowSize: 10,
};

export const DEMA = {
  // source: d => d.close, // "high", "low", "open", "close"
  sourcePath: "close",
  windowSize: 10,
};

// TEMA — Média Móvel Exponencial Tripla (migrado do Silverlight FML.TEMA;
// paridade via oráculo). N=12 é o default do engine. O DESLOCAR do engine é o
// `offsetBars`, aplicado genericamente em applyIndicators — não é opção de
// cálculo aqui.
export const TEMA = {
  sourcePath: "close",
  windowSize: 12,
};

export const Kagi = {
  reversalType: "ATR", // "ATR", "FIXED"
  windowSize: 14,
  reversal: 2,
  sourcePath: "close", // "high", "low", "open", "close"
  /* dateAccessor: d => d.date,
	dateMutator: (d, date) => { d.date = date; }, */
};

export const Renko = {
  mode: "auto", // "auto" | "fixed" | "atr"
  brickSize: null, // usado quando mode = "fixed"
  atrPeriod: 14, // período do ATR (quando mode = "atr")
  atrMultiplier: 1.0, // multiplicador do ATR (quando mode = "atr")
};

export const PointAndFigure = {
  boxSize: null, // null = automático (~30 colunas), number = tamanho fixo
  reversal: 3, // número de boxes para reversão (padrão: 3)
};

export const RangeBars = {
  range: 10, // The price range for each bar
  sourcePath: "close", // "close", "high", "low", "open"
};

export const CCI = {
  windowSize: 20,
  sourcePath: "close",
};

export const ADX = {
  windowSize: 14,
  smoothingPeriod: 14,
};

export const HiLoActivator = {
  highPeriod: 3,
  lowPeriod: 3,
};

export const DIDI = {
  sourcePath: "close",
  highPeriod: 3,
  midPeriod: 8,
  lowPeriod: 20,
};

export const Supertrend = {
  period: 7,
  multiplier: 3,
};

export const OnBalanceVolume = {
  sourcePath: "close",
  volumePath: "volume",
  minTickValue: 0,
};

export const TradeVolumeIndex = {
  sourcePath: "close",
  volumePath: "volume",
  minTickValue: 0.5,
};

export const WilliamsAD = {
  useVolume: false,
  volumePath: "volume",
};

export const SupportResistance = {
  // No parameters needed - uses current bar's High, Low, Close
};

export const RVI = {
  period: 10,
};

export const MedianPrice = {
  windowSize: 14,
};

export const Momentum = {
  windowSize: 14,
  sourcePath: "close",
};

export const DonchianChannel = {
  highPeriod: 20,
  lowPeriod: 20,
};

export const ZigZag = {
  distance: 10,
};

export const VolumeOscillator = {
  shortCycle: 12,
  longCycle: 26,
  pointsOrPercent: "Points",
};

export const STARCBands = {
  period: 15,
  maPeriod: 5,
  multiplier: 1.3,
  sourcePath: "close",
};

export const MAEnvelope = {
  period: 50,
  sourcePath: "close",
  movingAverageType: "sma",
  shiftType: "percent",
  shift: 5,
};

export const HighLow = {
  period: 14,
};

export const HHV = {
  period: 14,
};

export const LLV = {
  period: 14,
};

export const AwesomeOscillator = {
  fastPeriod: 5,
  slowPeriod: 34,
};

export const Aroon = {
  period: 14,
};

export const RelativeVolatility = {
  stdPeriod: 10,
  smoothingPeriod: 14,
  sourcePath: "close",
};

export const Alligator = {
  jawPeriod: 13,
  jawOffset: 8,
  teethPeriod: 8,
  teethOffset: 5,
  lipsPeriod: 5,
  lipsOffset: 3,
};

export const MADeviation = {
  windowSize: 12,
  sourcePath: "close",
  maType: "sma",
  mode: "Points",
};

export const PVT = {
  sourcePath: "close",
  volumePath: "volume",
};

export const RAVI = {
  shortPeriod: 7,
  longPeriod: 65,
  sourcePath: "close",
  maType: "sma",
};

export const vidya = {
  windowSize: 14,
  sourcePath: "close",
};

export const LinearForecast = {
  windowSize: 14,
  sourcePath: "close",
};

export const Shinohara = {
  period: 26,
};

export const PivotPoints = {
  type: "standard",
  continuous: false,
  period: "auto",
};

export const TrendIntensity = {
  period: 14,
  sourcePath: "close",
  signalPeriod: 9,
};

export const StochasticMomentum = {
  kPeriods: 10,
  kSmoothPeriods: 3,
  kDoubleSmoothPeriods: 3,
  dPeriods: 10,
  dMaType: "ema",
};

export const VolumeRateOfChange = {
  period: 14,
  volumePath: "volume",
};

export const PriceRateOfChange = {
  period: 14,
  sourcePath: "close",
};

export const ValuationLines = {
  sourcePath: "close",
  averageType: "mean",
};

export const PMO = {
  sourcePath: "close",
  smoothingPeriod: 35,
  doubleSmoothingPeriod: 20,
  signalPeriod: 10,
};

export const UltimateOscillator = {
  cycle1: 7,
  cycle2: 14,
  cycle3: 28,
};

export const NegativeVolumeIndex = {
  period: 255,
  sourcePath: "close",
  volumePath: "volume",
};

export const PositiveVolumeIndex = {
  period: 255,
  sourcePath: "close",
  volumePath: "volume",
};

export const Disparity = {
  windowSize: 14,
  sourcePath: "close",
  movingAverageType: "sma",
};

export const PriceOscillator = {
  shortPeriod: 12,
  longPeriod: 26,
  sourcePath: "close",
  movingAverageType: "ema",
  mode: "Points",
};

export const PSY = {
  windowSize: 20,
  sourcePath: "close",
};

export const IntradayMomentum = {
  windowSize: 20,
};

export const HistoricalVolatility = {
  windowSize: 10,
  sourcePath: "close",
  daysPerYear: 252,
  standardDeviations: 1,
};

export const BalanceOfPower = {
  windowSize: 14,
  movingAverageType: "sma",
};

export const StandardDeviation = {
  windowSize: 14,
  sourcePath: "close",
  movingAverageType: "sma",
  standardDeviations: 2,
};

export const LinearRegressionR2 = {
  period: 14,
  sourcePath: "close",
};

export const EhlerFisher = {
  period: 10,
};

export const ChandeMomentum = {
  period: 9,
  sourcePath: "close",
};

export const RainbowMA = {
  period: 2,
  sourcePath: "close",
};

export const TwiggsMF = {
  period: 21,
};

export const SwingIndex = {
  limitMoveValue: 0.5,
};

export const MassIndex = {
  period: 25, // N2 do engine (janela do somatório)
  emaPeriod: 9, // N1 do engine (EMA do range) — era fixo no código
  bulgeThreshold: 27,
};

export const TypicalPrice = {
  windowSize: 14,
};

export const Coppock = {
  period: 10,
  shortRoC: 11,
  longRoC: 14,
  sourcePath: "close",
};

export const FractalChaosBands = {};

export const LinearRegressionIntercept = {
  windowSize: 14,
  sourcePath: "close",
};

export const DarvasBox = {
  athLookbackPeriod: 100,
  exitField: "high/low",
  ghostBoxes: false,
  stopLevels: false,
  levelOffset: 0.01,
  priceMinimum: 5,
  volumeSpike: false,
  volumePercentOfAvg: 400,
};

// VR — Volatility Ratio (migrado do Silverlight FML.VR; paridade via oráculo)
export const VR = {
  period: 26,
};

// SRDM — Máximas e Mínimas (migrado do Silverlight FML.SRDM; paridade via oráculo)
export const SRDM = {
  period: 30,
};

// LWR — Estocástico Rápido Invertido Suavizado (migrado do Silverlight FML.LWR)
export const LWR = {
  period: 9,
  m1: 3,
  m2: 3,
};

// FastSTO — Estocástico Rápido (migrado do Silverlight FML.FastSTO, #368)
export const FastSTO = {
  period: 14,
  m: 3,
};

// DBCD — Convergência e Divergência de BIAS (migrado do Silverlight FML.DBCD)
export const DBCD = {
  period: 5,
  m: 16,
  t: 76,
};

// SROC — Smoothed Price Rate-of-Change (migrado do Silverlight FML.SROC)
export const SROC = {
  me: 13,
  period: 9,
  m: 0,
};

// MICD — Fec menos Fec Anterior Suavizado (migrado do Silverlight FML.MICD)
export const MICD = {
  period: 3,
  n1: 10,
  n2: 20,
};

// VHF — Filtro Vertical Horizontal (migrado do Silverlight FML.VHF)
export const VHF = {
  period: 28,
};

// VolHistHisto — Vol. Histórica (Histograma) (migrado do Silverlight FML.VolHistHisto)
export const VolHistHisto = {
  period: 20,
  m: 5,
};

// AroonOsc — Oscilador Aroon (migrado do Silverlight FML.AroonOsc)
export const AroonOsc = {
  period: 25,
};

// BIAS — Fechamento menos MA (migrado do Silverlight FML.BIAS)
export const BIAS = {
  l1: 6,
  l2: 12,
  l3: 24,
};

// MIKE — Maiores Altas e Baixas com a Média HLC (migrado do Silverlight FML.MIKE)
export const MIKE = {
  period: 12,
};

// CMF — Chaikin Money Flow (migrado do Silverlight FML.CMF; mesma fórmula do ChartIQ)
export const ChaikinMoneyFlow = {
  period: 20,
};

// VOLATI — Chaikin's Volatility (migrado do Silverlight FML.VOLATI; params
// separados como no ChartIQ — no legado os dois são o mesmo N)
export const ChaikinVolatility = {
  period: 10,
  rocPeriod: 10,
};

// DF — Difusor de Fluxo (FML.DF, Arena/XP): DIFF=EMA(C,SHORT)−EMA(C,LONG),
// DF−=EMA(DIFF,DF_MENOS), DF+=EMA(DIFF,DF_MAIS). 3 linhas, sem histograma.
export const DifusorFluxo = {
  long: 55,
  short: 21,
  dfMenos: 34,
  dfMais: 89,
};
